import * as React from 'react';
import { BaseComponentProps, BaseComponentState, BaseComponent } from '../base/BaseComponent'; 
export interface HomeFlightBannerProps extends BaseComponentProps { }
export interface HomeFlightBannerState extends BaseComponentState { }
export class HomeFlightBanner extends BaseComponent<HomeFlightBannerProps, HomeFlightBannerState> {
    render() {
        if ( this.state.haveReactError ) {
            return this.renderErrorPanel() ; 
        } 
        return (
            <section>
                <a href="https://flight.balihotelsandmore.com/" target='_blank'>
                     <img className="desktop-only" src="https://storage.googleapis.com/bali-hotel-images/balihotelsandmore-flight/fligt-banner.jpg" width='100%'/>
                     <img className="mobile-only" src="https://storage.googleapis.com/bali-hotel-images/balihotelsandmore-flight/fligt-banner-300.jpg" width='100%'/>
                </a>
            </section>
        );
    }
}



// WEBPACK FOOTER //
// ./src/home/HomeFlightBanner.tsx